export default "__VITE_ASSET__d5c65af8__"